export default __webpack_public_path__ + "static/challenges-27c4ca425086f8eff9c099f1f3705886.webp";